import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  utils: null,
};

export const utils = createSlice({
  name: "utils",
  initialState,
  reducers: {
    handleUtils: (state, action) => {
      state.utils = action.payload;
    },
  },
});

export const utilsState = (state) => state.utils;

export const { handleUtils } = utils.actions;

export default utils.reducer;
